// 261015 P4c-1 (D8/Q3/Q18) — nối tab "Tổng quan truyện" với khung Trợ lý ②. THUẦN (jest).
//
// BE mở "cửa sổ trích" của ý/quan hệ/câu V.O. mà tin nhắn NHẮC MÃ (so khớp theo biên từ, không phân biệt hoa/thường — `skeletonAssistant.ts`: `mentioned`).
// ⇒ FE gắn mã đang chọn thẳng vào chữ của tin nhắn; KHÔNG đổi `scopeKey`, KHÔNG gửi cả truyện.
import type { AssistantRequest } from '../assistant/assistantIntent';

export type AssistTarget =
  | { type: 'claim'; id: string; text?: string }
  | { type: 'relationship'; id: string; label?: string }
  | { type: 'introLine'; id: string; text?: string }
  | { type: 'profile'; id: string; label?: string };

const clip = (t: string | undefined, n: number): string => { const s = String(t ?? '').replace(/\s+/g, ' ').trim(); return s.length > n ? `${s.slice(0, n)}…` : s; };

/** Câu mở đầu điền sẵn vào ô soạn (không tự gửi — gửi là tốn AI). Luôn chứa MÃ của mục đang chọn. */
export const assistText = (t: AssistTarget): string => {
  switch (t.type) {
    case 'claim': return `Sửa ý ${t.id}${t.text ? ` ("${clip(t.text, 80)}")` : ''}: `;
    case 'relationship': return `Sửa quan hệ ${t.id}${t.label ? ` (${clip(t.label, 80)})` : ''}: `;
    case 'introLine': return `Sửa câu V.O. giới thiệu ${t.id}${t.text ? ` ("${clip(t.text, 80)}")` : ''}: `;
    case 'profile': return `Hồ sơ ${t.id}${t.label ? ` (${clip(t.label, 60)})` : ''} — sửa các ý của hồ sơ này: `;
  }
};

export const assistRequest = (t: AssistTarget): AssistantRequest => ({ stageKey: 'skeleton', issueIds: [], suggestedText: assistText(t) });

/** Trợ lý nói thật về khả năng của mình (D8): 4 lệnh, không thêm/xoá hồ sơ, đạo cụ, luật, phe. */
export const ASSISTANT_SCOPE_NOTE = 'Trợ lý ② sửa được nội dung và trích của MỘT ý, xoá một ý, sửa một quan hệ, sửa một câu V.O. giới thiệu. Thêm hoặc xoá hồ sơ nhân vật, đạo cụ, luật thế giới, phe: dùng nút "Sửa" / "Thêm" ở từng mục.';

/** Nhãn dự phòng cho 4 lệnh tổng quan của Trợ lý khi `command.labels` thiếu (BE vẫn là nguồn chính). */
export const OVERVIEW_ASSISTANT_OP_LABEL: Record<string, string> = {
  setOverviewClaim: 'Sửa ý trong tổng quan', removeOverviewClaim: 'Xoá ý khỏi tổng quan', upsertOverviewIntroLine: 'Sửa câu V.O. giới thiệu', upsertOverviewRelationship: 'Sửa quan hệ trong tổng quan',
};
export const OVERVIEW_ASSISTANT_OPS: ReadonlyArray<string> = Object.keys(OVERVIEW_ASSISTANT_OP_LABEL);
export const isOverviewAssistantOp = (op: string): boolean => OVERVIEW_ASSISTANT_OPS.includes(op);

/** Mô tả trong hộp "Áp đề xuất này?" khi khối có lệnh tổng quan: sửa tổng quan luôn kéo ② về nháp (D7), KHÔNG đụng khung xương / tập / kịch bản. */
export const OVERVIEW_APPLY_HINT = 'Sửa tổng quan đưa khung xương về bản nháp — cần "Chốt tổng quan" lại. Nhân vật, cao trào, dàn tập và kịch bản giữ nguyên; trích do hệ thống tự đối chiếu lại với nguyên tác lúc áp; bản cũ còn ở mục Phiên bản.';
